import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import YantraCardManagement from './components/YantraCardManagement';
import { CssBaseline, ThemeProvider, createTheme, Box } from '@mui/material';
import ManageTracks from './components/ManageTracks';
import Sidebar from './components/Sidebar';
import UserFeedbackComponent from './components/UserFeedback';
import PrivacyPolicy from './components/PrivacyPolicy';
import AboutUs from './components/AboutUs';
import TermsAndConditions from './components/TermsAndConditions';
import DeleteAccount from './components/DeleteAccount';
import Support from './components/Support';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FF7043', // Orange color from login screen
      light: '#FFB74D',
      dark: '#F4511E',
    },
    secondary: {
      main: '#FF7043',
    },
    background: {
      default: '#fafafa',
      paper: '#fff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '5px',
        },
      },
    },
  },
});

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuth();
  return currentUser ? (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {children}
      </Box>
    </Box>
  ) : (
    <Navigate to="/login" />
  );
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuth();
  return !currentUser ? <>{children}</> : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/support" element={<Support />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/yantra-cards" element={<PrivateRoute><YantraCardManagement /></PrivateRoute>} />
            <Route path="/manage-tracks" element={<PrivateRoute><ManageTracks /></PrivateRoute>} />
            <Route path="/user-feedback" element={<PrivateRoute><UserFeedbackComponent /></PrivateRoute>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 